import React, { useEffect, useRef } from 'react';

const AboutUs = () => {
  const contentRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      });
    }, observerOptions);

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => {
      if (contentRef.current) {
        observer.unobserve(contentRef.current);
      }
    };
  }, []);

  return (
    <section className="about-us-section" id="about-us">
      <div className="about-us-container">
        <h2 className="section-title">About Us</h2>
        <div className="content-paragraph" ref={contentRef}>
          <p>
            Welcome to VAT Calculator, your trusted partner for accurate and efficient VAT calculations. We understand that managing tax calculations can be complex and time-consuming, especially when dealing with multiple countries, currencies, and varying tax rates. That's why we've created a powerful, user-friendly tool that simplifies VAT calculations for businesses and individuals worldwide.
          </p>
          
          <p>
            Our mission is to provide fast, accurate, and easy-to-use VAT calculation tools that help you save time and eliminate errors. Whether you're a freelancer creating invoices, a small business owner managing expenses, or an accountant preparing financial reports, our calculator is designed to meet your needs with precision and reliability.
          </p>
          
          <h3 className="subsection-title">What We Offer</h3>
          <p>
            Our VAT calculator supports over 50 countries with their standard VAT rates, multiple currencies, and dual-mode functionality that allows you to add VAT to net amounts or remove VAT from gross amounts. We've built our tool with privacy in mind—all calculations are performed locally in your browser, ensuring your financial data never leaves your device.
          </p>
          
          <h3 className="subsection-title">Our Commitment</h3>
          <p>
            We are committed to providing free, accessible, and reliable financial tools that empower businesses and individuals to make informed decisions. Our calculator is continuously updated to reflect the latest VAT rates and regulations, ensuring you always have access to accurate information.
          </p>
          
          <p>
            Thank you for choosing VAT Calculator. We're here to make your tax calculations simpler, faster, and more accurate. If you have any questions, feedback, or suggestions, we'd love to hear from you.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
